module.exports = __webpack_public_path__ + "img/12_82.068bd500.png";